<div class="tw:text-end tw:mb-4">
	<button (click)="close()" class="tw:bg-transparent tw:text-secondary tw:border-none tw:text-base tw:font-medium">
		Close
	</button>
</div>

<div class="tw:flex tw:flex-col tw:gap-4 tw:pb-4">
	<app-bottom-menu-sheet-item
		icon="home_work"
		routerLink="/internal-views/schools"
		routerLinkActive="active"
		[hasSubMenu]="false"
	>
		School
	</app-bottom-menu-sheet-item>

	<app-bottom-menu-sheet-item
		icon="support_agent"
		routerLink="/internal-views/customer-support"
		routerLinkActive="active"
		[hasSubMenu]="false"
	>
		Support
	</app-bottom-menu-sheet-item>

	<app-bottom-menu-sheet-item
		icon="space_dashboard"
		routerLink="/internal-views/features"
		routerLinkActive="active"
		[hasSubMenu]="false"
	>
		Features
	</app-bottom-menu-sheet-item>

	<app-bottom-menu-sheet-item
		icon="rate_review"
		routerLink="/internal-views/feedback"
		routerLinkActive="active"
		[hasSubMenu]="false"
	>
		Feedback
	</app-bottom-menu-sheet-item>

	<app-bottom-menu-sheet-item
		icon="admin_panel_settings"
		routerLink="/internal-views/admin-functions"
		routerLinkActive="active"
		[hasSubMenu]="false"
	>
		Admin Functions
	</app-bottom-menu-sheet-item>

	<app-bottom-menu-sheet-item
		icon="rule_settings"
		routerLink="/internal-views/integrations"
		routerLinkActive="active"
		[hasSubMenu]="false"
	>
		Integrations
	</app-bottom-menu-sheet-item>
</div>
